/**
 * @file 搜索表单上下文
 * @description 标记 RequestTable 顶部筛选区，供输入框 / 选择框读取默认宽度。
 *
 * @whenToUse 仅由 RequestTable 的搜索表单包裹。
 * @whenNotToUse 登录、弹窗、页面主表单等非筛选场景。
 */

import { createContext, useContext, type ReactNode } from 'react'

const SearchFormContext = createContext(false)

/**
 * 搜索表单范围；内部的 Input / Select 等默认 `w-50`（200px）。
 */
export function SearchFormProvider({ children }: { children: ReactNode }) {
  return (
    <SearchFormContext.Provider value={true}>
      {children}
    </SearchFormContext.Provider>
  )
}

/**
 * 是否处于搜索表单内。
 */
export function useSearchForm(): boolean {
  return useContext(SearchFormContext)
}

/**
 * 搜索表单内默认 200px，其余场景撑满容器。
 * @param inSearchForm 是否在搜索表单内
 */
export function searchControlWidth(inSearchForm: boolean): 'w-50' | 'w-full' {
  return inSearchForm ? 'w-50' : 'w-full'
}
